import React from 'react';

/**
 * Campos del formulario del perfil. Centralizan el marcado accesible: el error
 * se anuncia con aria-invalid + aria-describedby en lugar de solo pintarse.
 */

export const CampoTexto = ({
  id, label, hint, error, name, value, onChange,
  type = 'text', autoComplete, disabled, placeholder,
}) => (
  <div className="perfil-form-campo">
    <label htmlFor={id}>{label}</label>
    {hint && <span className="perfil-form-hint" id={`${id}-hint`}>{hint}</span>}
    <input
      id={id}
      name={name}
      type={type}
      value={value ?? ''}
      onChange={onChange}
      disabled={disabled}
      placeholder={placeholder}
      autoComplete={autoComplete}
      className={error ? 'input-error' : ''}
      aria-invalid={error ? 'true' : undefined}
      aria-describedby={[hint && `${id}-hint`, error && `${id}-error`].filter(Boolean).join(' ') || undefined}
    />
    {error && <p className="campo-error" id={`${id}-error`}>{error}</p>}
  </div>
);

export const CampoSelect = ({ id, label, hint, name, value, onChange, children }) => (
  <div className="perfil-form-campo">
    <label htmlFor={id}>{label}</label>
    {hint && <span className="perfil-form-hint" id={`${id}-hint`}>{hint}</span>}
    <select
      id={id}
      name={name}
      value={value ?? ''}
      onChange={onChange}
      aria-describedby={hint ? `${id}-hint` : undefined}
    >
      {children}
    </select>
  </div>
);
